const XtsSection = () => {
  return (
    <section className="about about--style1 bg-color xts-section">
      <div className="container">
        <div className="about__wrapper">
          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
            <div className="col-lg-6">
              <div className="about__thumb pe-lg-5" data-aos="fade-right" data-aos-duration="800">
                <div className="about__thumb-inner">
                  <div className="about__thumb-image floating-content">
                    <img className="dark" src="/assets/images/new/xts-image.jpg" alt="XTS Trading Platform" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about__content" data-aos="fade-left" data-aos-duration="800">
                <div className="about__content-inner">
                  <h2 className="meet-oppurtanity">XTS Trading <span className="style2">Platform </span></h2>

                  <p>
                    XTS is advance enterprise scale sell side multi market and multi asset trading system from front to middle-office system to maximize efficiency, performance, transparency and give you a competitive edge.                  </p>
                  <p>
                    It offers advance front-ends (TWS, Mobile and Web), sophisticated order execution management System(OEMS), risk management system, manage compliances, direct exchange connectivity, market analytics, monitoring and reporting to provide a seamless trading experience to traders and Investors in broker-dealer setup with unified trading interface across exchanges and liquidity providers.                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-12 mt-30">
                <div className="benefits-section" data-aos="fade-up" data-aos-duration="800">
                    <div className="benefits-inner">
                        <h3 className="benefits-title">Key Aspects of XTS</h3>

                        <div className="benefits-list">

                        <div className="benefit-item">
                            <div className="benefit-icon">✓</div>
                            <div className="benefit-content">
                            <h5 className="benefit-heading">Multi-Asset Platform</h5>
                            <p className="benefit-text">
                                Supports trading across various financial instruments, including stocks, futures, options, and currencies.
                            </p>
                            </div>
                        </div>

                        <div className="benefit-item">
                            <div className="benefit-icon">✓</div>
                            <div className="benefit-content">
                            <h5 className="benefit-heading">Order & Execution Management</h5>
                            <p className="benefit-text">
                                Includes a sophisticated Order Management System (OMS) and Execution Management System (EMS) for managing the entire order lifecycle.
                            </p>
                            </div>
                        </div>

                        <div className="benefit-item">
                            <div className="benefit-icon">✓</div>
                            <div className="benefit-content">
                            <h5 className="benefit-heading">Trading Terminals</h5>
                            <p className="benefit-text">
                                Users can access the platform through intuitive desktop, web, and mobile trading terminals with advanced features.
                            </p>
                            </div>
                        </div>

                        <div className="benefit-item">
                            <div className="benefit-icon">✓</div>
                            <div className="benefit-content">
                            <h5 className="benefit-heading">APIs for Integration</h5>
                            <p className="benefit-text">
                                Provides REST-based APIs that allow developers to build custom trading interfaces and create their own trading solutions.
                            </p>
                            </div>
                        </div>

                        <div className="benefit-item">
                            <div className="benefit-icon">✓</div>
                            <div className="benefit-content">
                            <h5 className="benefit-heading">Algorithmic Trading Support</h5>
                            <p className="benefit-text">
                                Designed for algorithmic trading with features for developing, testing, and deploying trading strategies.
                            </p>
                            </div>
                        </div>

                        </div>

                    </div>
                </div>
            </div>
            <div className="col-lg-12 mt-30">
                <div className="about__content">
                    <div className="about__content-inner">
                    <h3 className="text-center" data-aos="fade-right" data-aos-duration="500">Platform Features</h3>
                    
                    <div className="platform-features">
                        <div className="feature-card" data-aos="fade-left" data-aos-duration="500">
                        <div className="feature-icon">
                            <i className="fas fa-chart-line"></i>
                        </div>
                        <div className="feature-title">Real-time Market Data</div>
                        <div className="feature-desc">Access to live market data with advanced charting tools and technical indicators</div>
                        </div>
                        
                        <div className="feature-card" data-aos="fade-down" data-aos-duration="500">
                        <div className="feature-icon">
                            <i className="fas fa-cogs"></i>
                        </div>
                        <div className="feature-title">Advanced Order Types</div>
                        <div className="feature-desc">Support for various order types including limit, market, stop-loss, and bracket orders</div>
                        </div>
                        
                        <div className="feature-card" data-aos="fade-right" data-aos-duration="500">
                        <div className="feature-icon">
                            <i className="fas fa-robot"></i>
                        </div>
                        <div className="feature-title">Algorithmic Trading</div>
                        <div className="feature-desc">Tools for developing, backtesting, and deploying automated trading strategies</div>
                        </div>
                        
                        <div className="feature-card" data-aos="fade-left" data-aos-duration="500">
                        <div className="feature-icon">
                            <i className="fas fa-mobile-alt"></i>
                        </div>
                        <div className="feature-title">Multi-Platform Access</div>
                        <div className="feature-desc">Available on web, desktop, and mobile devices for trading anywhere, anytime</div>
                        </div>
                        
                        <div className="feature-card" data-aos="fade-up" data-aos-duration="500">
                        <div className="feature-icon">
                            <i className="fas fa-shield-alt"></i>
                        </div>
                        <div className="feature-title">Risk Management</div>
                        <div className="feature-desc">Comprehensive risk management tools with real-time monitoring and alerts</div>
                        </div>
                        
                        <div className="feature-card" data-aos="fade-right" data-aos-duration="500">
                        <div className="feature-icon">
                            <i className="fas fa-code"></i>
                        </div>
                        <div className="feature-title">API Integration</div>
                        <div className="feature-desc">REST-based APIs for custom integration and development of trading applications</div>
                        </div>
                    </div>
                    
                    <h3 className="mt-4 text-center" data-aos="fade-down" data-aos-duration="500">How It's Used</h3>
                    
                    <div className="user-types">
                        <div className="user-type retail" data-aos="fade-up" data-aos-duration="500">
                        <div className="user-title">Retail Investors</div>
                        <div className="user-desc">Use the web, desktop, or mobile terminals to monitor markets, submit orders, and manage their portfolios with user-friendly interfaces.</div>
                        </div>
                        
                        <div className="user-type algo" data-aos="fade-up" data-aos-duration="500">
                        <div className="user-title">Algorithmic Traders</div>
                        <div className="user-desc">Leverage the low-latency APIs and algorithmic trading platform to backtest and deploy sophisticated trading strategies.</div>
                        </div>
                        
                        <div className="user-type broker" data-aos="fade-up" data-aos-duration="500">
                        <div className="user-title">Brokers</div>
                        <div className="user-desc">Use the platform to manage their operations, provide trading services to clients, and integrate with back-office systems.</div>
                        </div>
                    </div>
                    
                    <table className="comparison-table">
                        <thead>
                        <tr>
                            <th>User Type</th>
                            <th>Primary Features Used</th>
                            <th>Benefits</th>
                            <th>Access Methods</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td><b>Retail Traders</b></td>
                            <td>Web/Mobile terminals, Charting tools</td>
                            <td>User-friendly interface, Portfolio management</td>
                            <td>Web browser, Mobile app</td>
                        </tr>
                        <tr>
                            <td><b>Algorithmic Traders</b></td>
                            <td>API access, Backtesting tools</td>
                            <td>Strategy automation, Low latency execution</td>
                            <td>API, Desktop application</td>
                        </tr>
                        <tr>
                            <td><b>Brokers</b></td>
                            <td>Back-office integration, Compliance tools</td>
                            <td>Operational efficiency, Client management</td>
                            <td>Admin panels, Enterprise tools</td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default XtsSection;